// extracted by mini-css-extract-plugin
export default {"box":"v8n9WzkGCg0BO0gj798g","inputBox":"oU5IhBJCvgAJ4dTs8A0K","title":"G_DlK37f1_EBKYNiHMeU","fullRow":"kBFtFl9L3PGdzUFR8RHa"};